module.exports = __webpack_public_path__ + "img/c08_unitwarelephant_Normal_ua.99a357aa.webp";